export class LoadReferralsLastImport {
  public static type: string = '[Import] LoadReferralsLastImport';
}

export class ReferralsImportLinkedinDelete {
  public static type: string = '[Import] ReferralsImportLinkedinDelete';
}

export class ReferralsImportGoogleDelete {
  public static type: string = '[Import] ReferralsImportGoogleDelete';
}

export class ReferralsImportInitializeGoogle {
  public static type: string = '[Import] ReferralsImportInitializeGoogle';
}
